import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

const API = 'https://bacmt.com.ar';
/*const API = 'http://192.168.2.25:3000';*/

const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const labelEvento = (cod) => {
    const eventos = {
        1: 'Encendido', 2: 'Fin marcación', 3: 'Baja actividad pureza',
        4: 'Saturación pureza', 5: 'Pureza Ok', 6: 'Pureza mal',
        7: 'Moli Ok', 8: 'Moli mal', 9: 'Reposo', 10: 'Error horno',
        11: 'Alto fondo', 12: 'Modo servicio', 13: 'Proceso cancelado',
        14: 'Marcación mibi', 15: 'Marcación neuro', 16: 'Marcación osteo',
        17: 'Marcación programas', 18: 'Test pureza', 19: 'Test moli',
    };
    return eventos[cod] ?? cod;
};

const exportarExcelRegistros = (registros) => {
    const datos = registros.map(r => ({
        'ID': r.id, 'Dispositivo': r.dispositivo_id, 'Empresa': r.empresa_nombre || '—',
        'T.Real': r.tiempo_real===1?'Sí':'No', 'Cód.Evento': labelEvento(r.codigo_evento),
        'TSet': r.temp_set, 'TimeSet': r.time_set,
        'Fecha': new Date(r.fecha).toLocaleString(),
    }));
    const ws = XLSX.utils.json_to_sheet(datos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Registros');
    XLSX.writeFile(wb, `bacmt_admin_${new Date().toISOString().slice(0,10)}.xlsx`);
};

const exportarPDFRegistros = (registros) => {
    const doc = new jsPDF({ orientation: 'landscape' });
    doc.setFontSize(13); doc.text('BAC MT 2.0 — Registros (SuperAdmin)', 14, 14);
    doc.setFontSize(8); doc.text(`Exportado: ${new Date().toLocaleString()}`, 14, 20);
    autoTable(doc, {
        startY: 25,
        head: [['ID','Dispositivo','Empresa','T.Real','Cód.Evento','TSet','TimeSet','Fecha']],
        body: registros.map(r => [
            r.id, r.dispositivo_id, r.empresa_nombre||'—',
            r.tiempo_real===1?'Sí':'No', labelEvento(r.codigo_evento),
            r.temp_set, r.time_set, new Date(r.fecha).toLocaleString()
        ]),
        styles: { fontSize: 6.5 }, headStyles: { fillColor: [47,127,255] },
    });
    doc.save(`bacmt_admin_${new Date().toISOString().slice(0,10)}.pdf`);
};

function Admin() {
    const navigate = useNavigate();
    const [tab, setTab] = useState('empresas');
    return (
        <div style={s.page}>
            <Navbar />
            <div style={s.contenido}>
                <div style={s.header}>
                    <div>
                        <p style={s.headerSub}>PANEL DE ADMINISTRACIÓN</p>
                        <h2 style={s.headerTitulo}>Gestión del sistema</h2>
                    </div>
                    <button style={s.btnVolver} onClick={() => navigate('/dashboard')}>← Dashboard</button>
                </div>
                <div style={s.tabs}>
                    {[
                        { id: 'empresas',  label: '🏢 Empresas' },
                        { id: 'equipos',   label: '📡 Equipos' },
                        { id: 'usuarios',  label: '👤 Usuarios' },
                        { id: 'registros', label: '📋 Registros' },
                    ].map(t => (
                        <button key={t.id}
                            style={{ ...s.tab, ...(tab===t.id ? s.tabActivo : {}) }}
                            onClick={() => setTab(t.id)}>
                            {t.label}
                        </button>
                    ))}
                </div>
                {tab === 'empresas'  && <TabEmpresas />}
                {tab === 'equipos'   && <TabEquipos />}
                {tab === 'usuarios'  && <TabUsuarios />}
                {tab === 'registros' && <TabRegistros exportExcel={exportarExcelRegistros} exportPDF={exportarPDFRegistros} />}
            </div>
        </div>
    );
}

function TabEmpresas() {
    const [empresas, setEmpresas] = useState([]);
    const [form, setForm] = useState({ nombre: '', email: '', telefono: '', zona_horaria: 'America/Argentina/Buenos_Aires' });
    const [msg, setMsg] = useState(''); const [err, setErr] = useState(''); const [cargando, setCargando] = useState(false);

    // Edición
    const [editando, setEditando] = useState(null); // objeto empresa o null
    const [editForm, setEditForm] = useState({ nombre: '', email: '', telefono: '', zona_horaria: '' });
    const [editMsg, setEditMsg] = useState({ tipo: '', texto: '' });
    const [editGuardando, setEditGuardando] = useState(false);

    const traer = useCallback(async () => {
        try { const r = await axios.get(`${API}/api/empresas`, { headers: headers() }); setEmpresas(r.data); }
        catch { setErr('Error cargando empresas'); }
    }, []);

    useEffect(() => { traer(); }, [traer]);

    const crear = async (e) => {
        e.preventDefault(); setMsg(''); setErr(''); setCargando(true);
        try {
            await axios.post(`${API}/api/empresas`, form, { headers: headers() });
            setMsg('Empresa creada con éxito');
            setForm({ nombre: '', email: '', telefono: '', zona_horaria: 'America/Argentina/Buenos_Aires' });
            traer();
        } catch (error) { setErr(error.response?.data?.error || 'Error'); }
        finally { setCargando(false); }
    };

    const toggleEstado = async (id, activo) => {
        try { await axios.post(`${API}/api/empresas/${id}/estado`, { activo: !activo }, { headers: headers() }); traer(); }
        catch { setErr('Error al cambiar estado'); }
    };

    const abrirEdicion = (emp) => {
        setEditando(emp);
        setEditForm({ nombre: emp.nombre || '', email: emp.email || '', telefono: emp.telefono || '', zona_horaria: emp.zona_horaria || '' });
        setEditMsg({ tipo: '', texto: '' });
    };

    const guardarEdicion = async () => {
        if (!editForm.nombre.trim() || !editForm.email.trim()) {
            setEditMsg({ tipo: 'error', texto: 'Nombre y email son obligatorios.' });
            return;
        }
        setEditGuardando(true); setEditMsg({ tipo: '', texto: '' });
        try {
            await axios.put(`${API}/api/empresas/${editando.id}`, {
                nombre: editForm.nombre.trim(),
                email: editForm.email.trim(),
                telefono: editForm.telefono.trim() || null,
                zona_horaria: editForm.zona_horaria.trim() || null,
            }, { headers: headers() });
            setEditMsg({ tipo: 'ok', texto: '✓ Empresa actualizada.' });
            traer();
            setTimeout(() => setEditando(null), 800);
        } catch (error) {
            setEditMsg({ tipo: 'error', texto: '⚠ ' + (error.response?.data?.error || 'No se pudo guardar.') });
        } finally { setEditGuardando(false); }
    };

    return (
        <div style={s.tabContent}>
            <div style={s.card}>
                <p style={s.cardTitulo}>Nueva empresa</p>
                <form onSubmit={crear} style={s.form}>
                    <div style={s.formRow}>
                        <div style={s.campo}><label style={s.label}>Nombre *</label><input style={s.input} value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Nombre de la empresa" required /></div>
                        <div style={s.campo}><label style={s.label}>Email *</label><input style={s.input} type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="contacto@empresa.com" required /></div>
                        <div style={s.campo}><label style={s.label}>Teléfono</label><input style={s.input} value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} placeholder="+54 11 0000-0000" /></div>
                        <div style={s.campo}><label style={s.label}>Zona horaria</label><input style={s.input} value={form.zona_horaria} onChange={e => setForm({...form, zona_horaria: e.target.value})} placeholder="America/Argentina/Buenos_Aires" /></div>
                        <button type="submit" style={s.btnPrimario} disabled={cargando}>{cargando ? 'Creando...' : '+ Crear'}</button>
                    </div>
                    {msg && <div style={s.successBox}>✓ {msg}</div>}
                    {err && <div style={s.errorBox}>⚠ {err}</div>}
                </form>
            </div>
            <div style={s.tablaWrap}>
                <div style={s.tablaHeader}><span style={s.tablaCount}>{empresas.length} empresas</span></div>
                <table style={s.tabla}>
                    <thead><tr>{['ID','Nombre','Email','Teléfono','Zona horaria','Usuarios','Equipos','Estado','Alta','Acción'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                    <tbody>
                        {empresas.length === 0 ? <tr><td colSpan="10" style={s.tdVacio}>Sin empresas...</td></tr>
                        : empresas.map(emp => (
                            <tr key={emp.id}>
                                <td style={{...s.td,...s.tdMono}}>#{emp.id}</td>
                                <td style={{...s.td,fontWeight:'500'}}>{emp.nombre}</td>
                                <td style={{...s.td,...s.tdMono,fontSize:'0.78rem'}}>{emp.email}</td>
                                <td style={s.td}>{emp.telefono || '—'}</td>
                                <td style={{...s.td,...s.tdMono,fontSize:'0.75rem'}}>{emp.zona_horaria}</td>
                                <td style={{...s.td,...s.tdMono}}>{emp.total_usuarios}</td>
                                <td style={{...s.td,...s.tdMono}}>{emp.total_equipos}</td>
                                <td style={s.td}><span style={{...s.pill,...(emp.activo ? s.pillVerde : s.pillRojo)}}>{emp.activo ? 'Activa' : 'Inactiva'}</span></td>
                                <td style={{...s.td,...s.tdMono,fontSize:'0.76rem'}}>{new Date(emp.fecha_creacion).toLocaleDateString()}</td>
                                <td style={s.td}>
                                    <div style={{display:'flex',gap:'6px'}}>
                                        <button style={{...s.btnAccion,...s.btnEditar}} onClick={() => abrirEdicion(emp)}>Editar</button>
                                        <button style={{...s.btnAccion,...(emp.activo ? s.btnDesactivar : s.btnActivar)}} onClick={() => toggleEstado(emp.id, emp.activo)}>{emp.activo ? 'Desactivar' : 'Activar'}</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {editando && (
                <div style={s.modalOverlay} onClick={() => setEditando(null)}>
                    <div style={s.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={s.modalHeader}>
                            <div><p style={s.modalSub}>EDITAR EMPRESA #{editando.id}</p><h3 style={s.modalTitulo}>{editando.nombre}</h3></div>
                            <button style={s.modalClose} onClick={() => setEditando(null)}>×</button>
                        </div>
                        <label style={s.modalLabel}>Nombre *</label>
                        <input style={s.input} value={editForm.nombre} onChange={e => setEditForm({...editForm, nombre: e.target.value})} />
                        <label style={s.modalLabel}>Email *</label>
                        <input style={s.input} value={editForm.email} onChange={e => setEditForm({...editForm, email: e.target.value})} />
                        <label style={s.modalLabel}>Teléfono</label>
                        <input style={s.input} value={editForm.telefono} onChange={e => setEditForm({...editForm, telefono: e.target.value})} />
                        <label style={s.modalLabel}>Zona horaria</label>
                        <input style={s.input} value={editForm.zona_horaria} onChange={e => setEditForm({...editForm, zona_horaria: e.target.value})} />
                        {editMsg.texto && <div style={{...s.modalMsg, ...(editMsg.tipo==='ok'?s.successBox:s.errorBox)}}>{editMsg.texto}</div>}
                        <div style={s.modalAcciones}>
                            <button style={s.modalBtnCancelar} onClick={() => setEditando(null)} disabled={editGuardando}>Cancelar</button>
                            <button style={s.btnPrimario} onClick={guardarEdicion} disabled={editGuardando}>{editGuardando ? 'Guardando...' : 'Guardar cambios'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function TabEquipos() {
    const [equipos, setEquipos] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [form, setForm] = useState({ serie: '', num_interno: '', descripcion: '', id_empresa: '' });
    const [msg, setMsg] = useState(''); const [err, setErr] = useState(''); const [cargando, setCargando] = useState(false);

    const traer = useCallback(async () => {
        try {
            const [resEq, resEmp] = await Promise.all([
                axios.get(`${API}/api/equipos`, { headers: headers() }),
                axios.get(`${API}/api/empresas`, { headers: headers() }),
            ]);
            setEquipos(resEq.data); setEmpresas(resEmp.data);
        } catch { setErr('Error cargando datos'); }
    }, []);

    useEffect(() => { traer(); }, [traer]);

    const crear = async (e) => {
        e.preventDefault(); setMsg(''); setErr(''); setCargando(true);
        try {
            await axios.post(`${API}/api/equipos`, form, { headers: headers() });
            setMsg(`Equipo ${form.serie} registrado con éxito`);
            setForm({ serie: '', num_interno: '', descripcion: '', id_empresa: '' });
            traer();
        } catch (error) { setErr(error.response?.data?.error || 'Error'); }
        finally { setCargando(false); }
    };

    const asignar = async (id, id_empresa) => {
        try { await axios.post(`${API}/api/equipos/${id}/asignar`, { id_empresa: id_empresa||null }, { headers: headers() }); traer(); }
        catch { setErr('Error al asignar'); }
    };

    const toggleEstado = async (id, estado) => {
        const nuevo = estado === 'activo' ? 'inactivo' : 'activo';
        try { await axios.post(`${API}/api/admin/equipos/${id}/estado`, { estado: nuevo }, { headers: headers() }); traer(); }
        catch { setErr('Error al cambiar estado'); }
    };

    // Edición
    const [editando, setEditando] = useState(null);
    const [editForm, setEditForm] = useState({ serie: '', num_interno: '', descripcion: '' });
    const [editMsg, setEditMsg] = useState({ tipo: '', texto: '' });
    const [editGuardando, setEditGuardando] = useState(false);

    const abrirEdicion = (eq) => {
        setEditando(eq);
        setEditForm({ serie: eq.serie || '', num_interno: eq.num_interno || '', descripcion: eq.descripcion || '' });
        setEditMsg({ tipo: '', texto: '' });
    };

    const guardarEdicion = async () => {
        if (!editForm.serie.trim() || !editForm.num_interno.trim()) {
            setEditMsg({ tipo: 'error', texto: 'Serie y número interno son obligatorios.' });
            return;
        }
        setEditGuardando(true); setEditMsg({ tipo: '', texto: '' });
        try {
            await axios.put(`${API}/api/admin/equipos/${editando.id}`, {
                serie: editForm.serie.trim(),
                num_interno: editForm.num_interno.trim().toUpperCase(),
                descripcion: editForm.descripcion.trim() || null,
            }, { headers: headers() });
            setEditMsg({ tipo: 'ok', texto: '✓ Equipo actualizado.' });
            traer();
            setTimeout(() => setEditando(null), 800);
        } catch (error) {
            setEditMsg({ tipo: 'error', texto: '⚠ ' + (error.response?.data?.error || 'No se pudo guardar.') });
        } finally { setEditGuardando(false); }
    };

    return (
        <div style={s.tabContent}>
            <div style={s.card}>
                <p style={s.cardTitulo}>Registrar nuevo equipo</p>
                <p style={s.cardDesc}>El número interno identifica al equipo. La serie es el ID del hardware.</p>
                <form onSubmit={crear} style={s.form}>
                    <div style={s.formRow}>
                        <div style={s.campo}><label style={s.label}>Número de serie *</label><input style={s.input} value={form.serie} onChange={e => setForm({...form, serie: e.target.value})} placeholder="Ej: BMT5740-0086" required /></div>
                        <div style={s.campo}><label style={s.label}>Número Interno *</label><input style={{...s.input,fontFamily:'IBM Plex Mono,monospace',textTransform:'uppercase'}} value={form.num_interno} onChange={e => setForm({...form, num_interno: e.target.value.toUpperCase()})} placeholder="Ej: 10FDABAE3D9" required /></div>
                        <div style={s.campo}><label style={s.label}>Descripción</label><input style={s.input} value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})} placeholder="" /></div>
                        <div style={s.campo}>
                            <label style={s.label}>Asignar a empresa</label>
                            <select style={s.input} value={form.id_empresa} onChange={e => setForm({...form, id_empresa: e.target.value})}>
                                <option value="">Sin asignar</option>
                                {empresas.map(emp => <option key={emp.id} value={emp.id}>{emp.nombre}</option>)}
                            </select>
                        </div>
                        <button type="submit" style={s.btnPrimario} disabled={cargando}>{cargando ? 'Registrando...' : '+ Registrar'}</button>
                    </div>
                    {msg && <div style={s.successBox}>✓ {msg}</div>}
                    {err && <div style={s.errorBox}>⚠ {err}</div>}
                </form>
            </div>
            <div style={s.tablaWrap}>
                <div style={s.tablaHeader}><span style={s.tablaCount}>{equipos.length} equipos</span></div>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ ...s.tabla, minWidth: '900px' }}>
                        <thead><tr>{['ID','Serie','Num_interno','Descripción','Empresa','Estado','Alta','Asignar','Acción','Editar'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                        <tbody>
                            {equipos.length === 0 ? <tr><td colSpan="9" style={s.tdVacio}>Sin equipos...</td></tr>
                            : equipos.map(eq => (
                                <tr key={eq.id}>
                                    <td style={{...s.td,...s.tdMono}}>#{eq.id}</td>
                                    <td style={{...s.td,...s.tdMono}}>{eq.serie}</td>
                                    <td style={{...s.td,...s.tdMono}}>{eq.num_interno || '—'}</td>
                                    <td style={s.td}>{eq.descripcion || '—'}</td>
                                    <td style={s.td}>{eq.empresa_nombre ? <span style={s.usuarioBadge}>{eq.empresa_nombre}</span> : <span style={{color:'var(--text-dim)',fontSize:'0.78rem'}}>Sin asignar</span>}</td>
                                    <td style={s.td}><span style={{...s.pill,...(eq.estado==='activo'?s.pillVerde:s.pillRojo)}}>{eq.estado}</span></td>
                                    <td style={{...s.td,...s.tdMono,fontSize:'0.76rem'}}>{new Date(eq.fecha_alta).toLocaleDateString()}</td>
                                    <td style={s.td}>
                                        <select style={{...s.input,padding:'4px 8px',fontSize:'0.75rem',minWidth:'140px'}} value={eq.id_empresa || ''} onChange={e => asignar(eq.id, e.target.value)}>
                                            <option value="">Sin asignar</option>
                                            {empresas.map(emp => <option key={emp.id} value={emp.id}>{emp.nombre}</option>)}
                                        </select>
                                    </td>
                                    <td style={s.td}><button style={{...s.btnAccion,...(eq.estado==='activo'?s.btnDesactivar:s.btnActivar)}} onClick={() => toggleEstado(eq.id, eq.estado)}>{eq.estado==='activo'?'Desactivar':'Activar'}</button></td>
                                    <td style={s.td}><button style={{...s.btnAccion,...s.btnEditar}} onClick={() => abrirEdicion(eq)}>Editar</button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {editando && (
                <div style={s.modalOverlay} onClick={() => setEditando(null)}>
                    <div style={s.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={s.modalHeader}>
                            <div><p style={s.modalSub}>EDITAR EQUIPO #{editando.id}</p><h3 style={s.modalTitulo}>{editando.serie}</h3></div>
                            <button style={s.modalClose} onClick={() => setEditando(null)}>×</button>
                        </div>
                        <p style={s.cardDesc}>Corregí serie, número interno o descripción. El número interno es el que reporta el hardware — cuidá que coincida exactamente.</p>
                        <label style={s.modalLabel}>Número de serie *</label>
                        <input style={s.input} value={editForm.serie} onChange={e => setEditForm({...editForm, serie: e.target.value})} />
                        <label style={s.modalLabel}>Número interno *</label>
                        <input style={{...s.input,fontFamily:'IBM Plex Mono,monospace',textTransform:'uppercase'}} value={editForm.num_interno} onChange={e => setEditForm({...editForm, num_interno: e.target.value.toUpperCase()})} />
                        <label style={s.modalLabel}>Descripción</label>
                        <input style={s.input} value={editForm.descripcion} onChange={e => setEditForm({...editForm, descripcion: e.target.value})} />
                        {editMsg.texto && <div style={{...s.modalMsg, ...(editMsg.tipo==='ok'?s.successBox:s.errorBox)}}>{editMsg.texto}</div>}
                        <div style={s.modalAcciones}>
                            <button style={s.modalBtnCancelar} onClick={() => setEditando(null)} disabled={editGuardando}>Cancelar</button>
                            <button style={s.btnPrimario} onClick={guardarEdicion} disabled={editGuardando}>{editGuardando ? 'Guardando...' : 'Guardar cambios'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function TabUsuarios() {
    const [usuarios, setUsuarios] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [form, setForm] = useState({ nombre: '', email: '', password: '', rol: 'operador', id_empresa: '' });
    const [msg, setMsg] = useState(''); const [err, setErr] = useState(''); const [cargando, setCargando] = useState(false);

    const traer = useCallback(async () => {
        try {
            const [resUs, resEmp] = await Promise.all([
                axios.get(`${API}/api/usuarios`, { headers: headers() }),
                axios.get(`${API}/api/empresas`, { headers: headers() }),
            ]);
            setUsuarios(resUs.data); setEmpresas(resEmp.data);
        } catch { setErr('Error cargando datos'); }
    }, []);

    useEffect(() => { traer(); }, [traer]);

    const crear = async (e) => {
        e.preventDefault(); setMsg(''); setErr(''); setCargando(true);
        try {
            await axios.post(`${API}/api/admin/usuarios`, form, { headers: headers() });
            setMsg(`Usuario ${form.email} creado con éxito`);
            setForm({ nombre: '', email: '', password: '', rol: 'operador', id_empresa: '' });
            traer();
        } catch (error) { setErr(error.response?.data?.error || 'Error'); }
        finally { setCargando(false); }
    };

    const toggleEstado = async (id, activo) => {
        try { await axios.post(`${API}/api/admin/usuarios/${id}/estado`, { activo: !activo }, { headers: headers() }); traer(); }
        catch { setErr('Error al cambiar estado'); }
    };

    // Edición (email NO editable: es con lo que se loguea)
    const [editando, setEditando] = useState(null);
    const [editForm, setEditForm] = useState({ nombre: '', rol: 'operador', id_empresa: '' });
    const [editMsg, setEditMsg] = useState({ tipo: '', texto: '' });
    const [editGuardando, setEditGuardando] = useState(false);

    // Reset de contraseña por mail
    const [reseteando, setReseteando] = useState(null); // id del usuario en proceso

    const resetearPassword = async (u) => {
        if (!window.confirm(`¿Enviar mail de reseteo de contraseña a ${u.email}?`)) return;
        setReseteando(u.id);
        try {
            const res = await axios.post(`${API}/api/admin/usuarios/${u.id}/reset-password`, {}, { headers: headers() });
            alert(res.data?.mensaje || 'Mail de reseteo enviado.');
        } catch (error) {
            alert('⚠ ' + (error.response?.data?.error || 'No se pudo enviar el mail.'));
        } finally { setReseteando(null); }
    };

    const abrirEdicion = (u) => {
        setEditando(u);
        setEditForm({ nombre: u.nombre || '', rol: u.rol || 'operador', id_empresa: u.id_empresa || '' });
        setEditMsg({ tipo: '', texto: '' });
    };

    const guardarEdicion = async () => {
        if (!editForm.nombre.trim()) {
            setEditMsg({ tipo: 'error', texto: 'El nombre es obligatorio.' });
            return;
        }
        setEditGuardando(true); setEditMsg({ tipo: '', texto: '' });
        try {
            await axios.put(`${API}/api/admin/usuarios/${editando.id}`, {
                nombre: editForm.nombre.trim(),
                rol: editForm.rol,
                id_empresa: editForm.id_empresa || null,
            }, { headers: headers() });
            setEditMsg({ tipo: 'ok', texto: '✓ Usuario actualizado.' });
            traer();
            setTimeout(() => setEditando(null), 800);
        } catch (error) {
            setEditMsg({ tipo: 'error', texto: '⚠ ' + (error.response?.data?.error || 'No se pudo guardar.') });
        } finally { setEditGuardando(false); }
    };

    const rolColor = (rol) => {
        if (rol === 'superadmin') return s.pillAmbar;
        if (rol === 'admin_empresa') return s.pillCyan;
        return s.pillGris;
    };

    return (
        <div style={s.tabContent}>
            <div style={s.card}>
                <p style={s.cardTitulo}>Nuevo usuario</p>
                <form onSubmit={crear} style={s.form}>
                    <div style={s.formRow}>
                        <div style={s.campo}><label style={s.label}>Nombre *</label><input style={s.input} value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Nombre completo" required /></div>
                        <div style={s.campo}><label style={s.label}>Email *</label><input style={s.input} type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="email@empresa.com" required /></div>
                        <div style={s.campo}><label style={s.label}>Contraseña *</label><input style={s.input} type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="••••••••" required /></div>
                        <div style={s.campo}>
                            <label style={s.label}>Rol *</label>
                            <select style={s.input} value={form.rol} onChange={e => setForm({...form, rol: e.target.value})}>
                                <option value="operador">Operador</option>
                                <option value="admin_empresa">Admin empresa</option>
                                <option value="superadmin">Superadmin</option>
                            </select>
                        </div>
                        <div style={s.campo}>
                            <label style={s.label}>Empresa</label>
                            <select style={s.input} value={form.id_empresa} onChange={e => setForm({...form, id_empresa: e.target.value})}>
                                <option value="">Sin empresa (superadmin)</option>
                                {empresas.map(emp => <option key={emp.id} value={emp.id}>{emp.nombre}</option>)}
                            </select>
                        </div>
                        <button type="submit" style={s.btnPrimario} disabled={cargando}>{cargando ? 'Creando...' : '+ Crear'}</button>
                    </div>
                    {msg && <div style={s.successBox}>✓ {msg}</div>}
                    {err && <div style={s.errorBox}>⚠ {err}</div>}
                </form>
            </div>
            <div style={s.tablaWrap}>
                <div style={s.tablaHeader}><span style={s.tablaCount}>{usuarios.length} usuarios</span></div>
                <table style={s.tabla}>
                    <thead><tr>{['ID','Nombre','Email','Rol','Empresa','Estado','Alta','Acción'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                    <tbody>
                        {usuarios.length === 0 ? <tr><td colSpan="8" style={s.tdVacio}>Sin usuarios...</td></tr>
                        : usuarios.map(u => (
                            <tr key={u.id}>
                                <td style={{...s.td,...s.tdMono}}>#{u.id}</td>
                                <td style={{...s.td,fontWeight:'500'}}>{u.nombre}</td>
                                <td style={{...s.td,...s.tdMono,fontSize:'0.78rem'}}>{u.email}</td>
                                <td style={s.td}><span style={{...s.pill,...rolColor(u.rol)}}>{u.rol}</span></td>
                                <td style={s.td}>{u.empresa_nombre ? <span style={s.usuarioBadge}>{u.empresa_nombre}</span> : <span style={{color:'var(--text-dim)',fontSize:'0.78rem'}}>—</span>}</td>
                                <td style={s.td}><span style={{...s.pill,...(u.activo?s.pillVerde:s.pillRojo)}}>{u.activo?'Activo':'Inactivo'}</span></td>
                                <td style={{...s.td,...s.tdMono,fontSize:'0.76rem'}}>{new Date(u.fecha_creacion).toLocaleDateString()}</td>
                                <td style={s.td}>
                                    <div style={{display:'flex',gap:'6px',flexWrap:'wrap'}}>
                                        <button style={{...s.btnAccion,...s.btnEditar}} onClick={() => abrirEdicion(u)}>Editar</button>
                                        <button style={{...s.btnAccion,...s.btnReset}} onClick={() => resetearPassword(u)} disabled={reseteando === u.id}>
                                            {reseteando === u.id ? 'Enviando...' : 'Reset pass'}
                                        </button>
                                        {u.rol !== 'superadmin' && (
                                            <button style={{...s.btnAccion,...(u.activo?s.btnDesactivar:s.btnActivar)}} onClick={() => toggleEstado(u.id, u.activo)}>
                                                {u.activo ? 'Desactivar' : 'Activar'}
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {editando && (
                <div style={s.modalOverlay} onClick={() => setEditando(null)}>
                    <div style={s.modal} onClick={(e) => e.stopPropagation()}>
                        <div style={s.modalHeader}>
                            <div><p style={s.modalSub}>EDITAR USUARIO #{editando.id}</p><h3 style={s.modalTitulo}>{editando.nombre}</h3></div>
                            <button style={s.modalClose} onClick={() => setEditando(null)}>×</button>
                        </div>
                        <label style={s.modalLabel}>Nombre *</label>
                        <input style={s.input} value={editForm.nombre} onChange={e => setEditForm({...editForm, nombre: e.target.value})} />
                        <label style={s.modalLabel}>Email (no editable)</label>
                        <input style={{...s.input, opacity:0.55, cursor:'not-allowed'}} value={editando.email} disabled readOnly />
                        <label style={s.modalLabel}>Rol *</label>
                        <select style={s.input} value={editForm.rol} onChange={e => setEditForm({...editForm, rol: e.target.value})}>
                            <option value="operador">Operador</option>
                            <option value="admin_empresa">Admin empresa</option>
                            <option value="superadmin">Superadmin</option>
                        </select>
                        <label style={s.modalLabel}>Empresa</label>
                        <select style={s.input} value={editForm.id_empresa} onChange={e => setEditForm({...editForm, id_empresa: e.target.value})}>
                            <option value="">Sin empresa (superadmin)</option>
                            {empresas.map(emp => <option key={emp.id} value={emp.id}>{emp.nombre}</option>)}
                        </select>
                        {editMsg.texto && <div style={{...s.modalMsg, ...(editMsg.tipo==='ok'?s.successBox:s.errorBox)}}>{editMsg.texto}</div>}
                        <div style={s.modalAcciones}>
                            <button style={s.modalBtnCancelar} onClick={() => setEditando(null)} disabled={editGuardando}>Cancelar</button>
                            <button style={s.btnPrimario} onClick={guardarEdicion} disabled={editGuardando}>{editGuardando ? 'Guardando...' : 'Guardar cambios'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function TabRegistros({ exportExcel, exportPDF }) {
    const [registros, setRegistros] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [filtro, setFiltro] = useState('todos');
    const [ultimaAct, setUltimaAct] = useState(null);

    const traer = useCallback(async () => {
        try {
            const [resReg, resEmp] = await Promise.all([
                axios.get(`${API}/api/admin/registros`, { headers: headers() }),
                axios.get(`${API}/api/empresas`, { headers: headers() }),
            ]);
            setRegistros(resReg.data); setEmpresas(resEmp.data); setUltimaAct(new Date());
        } catch (e) { console.error(e); }
    }, []);

    useEffect(() => { traer(); const t = setInterval(traer, 10000); return () => clearInterval(t); }, [traer]);

    const datos = filtro === 'todos' ? registros : registros.filter(r => String(r.id_empresa) === filtro);

    return (
        <div style={s.tabContent}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-end',flexWrap:'wrap',gap:'12px'}}>
                <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
                    <label style={s.label}>FILTRAR POR EMPRESA</label>
                    <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                        <button style={{...s.filtroBtn,...(filtro==='todos'?s.filtroBtnActivo:{})}} onClick={() => setFiltro('todos')}>Todas</button>
                        {empresas.map(emp => (
                            <button key={emp.id} style={{...s.filtroBtn,...(filtro===String(emp.id)?s.filtroBtnActivo:{})}} onClick={() => setFiltro(String(emp.id))}>{emp.nombre}</button>
                        ))}
                    </div>
                </div>
                <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                    <span style={{...s.tdMono,fontSize:'0.72rem',color:'var(--text-muted)'}}>{datos.length} registros</span>
                    {ultimaAct && <span style={{...s.tdMono,fontSize:'0.72rem',color:'var(--text-muted)'}}>Act. {ultimaAct.toLocaleTimeString()}</span>}
                    <button style={s.btnExcel} onClick={() => exportExcel(datos)} disabled={!datos.length}>↓ Excel</button>
                    <button style={s.btnPDF} onClick={() => exportPDF(datos)} disabled={!datos.length}>↓ PDF</button>
                </div>
            </div>
            <div style={s.tablaWrap}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ ...s.tabla, minWidth: '800px' }}>
                        <thead><tr>{['ID','Dispositivo','Empresa','T.Real','Cód.Evento','Temp.Set','TimeSet','Fecha'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                        <tbody>
                            {datos.length === 0 ? <tr><td colSpan="8" style={s.tdVacio}>Sin registros...</td></tr>
                            : datos.map((r,i) => (
                                <tr key={r.id} style={i===0?s.trPrimero:{}}>
                                    <td style={{...s.td,...s.tdMono}}>#{r.id}</td>
                                    <td style={s.td}><span style={s.dispBadge}>{r.dispositivo_id}</span></td>
                                    <td style={s.td}><span style={s.usuarioBadge}>{r.empresa_nombre||'—'}</span></td>
                                    <td style={s.td}><span style={{...s.pill,...(r.tiempo_real?s.pillVerde:s.pillGris)}}>{r.tiempo_real?'Sí':'No'}</span></td>
                                    <td style={s.td}>{r.codigo_evento != null ? labelEvento(r.codigo_evento) : '—'}</td>
                                    <td style={{...s.td,...s.tdMono}}>{r.temp_set!=null?`${r.temp_set}°`:'—'}</td>
                                    <td style={{...s.td,...s.tdMono}}>{r.time_set!=null?`${r.time_set}min`:'—'}</td>
                                    <td style={{...s.td,...s.tdMono,fontSize:'0.74rem'}}>{new Date(r.fecha).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

const s = {
    page: { minHeight:'100vh', backgroundColor:'var(--bg-base)' },
    contenido: { padding:'28px 36px', maxWidth:'1400px', margin:'0 auto' },
    header: { display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:'24px' },
    headerSub: { fontSize:'0.7rem', color:'var(--accent)', letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:'6px' },
    headerTitulo: { fontSize:'1.5rem', fontWeight:'600', color:'var(--text-primary)', letterSpacing:'-0.02em' },
    btnVolver: { background:'none', border:'1px solid var(--border-light)', color:'var(--text-muted)', padding:'7px 16px', borderRadius:'7px', cursor:'pointer', fontFamily:'IBM Plex Sans,sans-serif', fontSize:'0.85rem' },
    tabs: { display:'flex', gap:'4px', marginBottom:'24px', borderBottom:'1px solid var(--border)' },
    tab: { background:'none', border:'none', borderBottom:'2px solid transparent', color:'var(--text-muted)', padding:'10px 20px', fontSize:'0.875rem', fontFamily:'IBM Plex Sans,sans-serif', cursor:'pointer', marginBottom:'-1px', transition:'all 0.15s' },
    tabActivo: { color:'var(--accent)', borderBottomColor:'var(--accent)', fontWeight:'500' },
    tabContent: { display:'flex', flexDirection:'column', gap:'20px' },
    card: { backgroundColor:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', padding:'22px 24px' },
    cardTitulo: { fontSize:'0.95rem', fontWeight:'600', color:'var(--text-primary)', marginBottom:'6px' },
    cardDesc: { fontSize:'0.8rem', color:'var(--text-muted)', marginBottom:'18px', lineHeight:'1.5' },
    form: { display:'flex', flexDirection:'column', gap:'12px' },
    formRow: { display:'flex', gap:'12px', alignItems:'flex-end', flexWrap:'wrap' },
    campo: { display:'flex', flexDirection:'column', gap:'6px', flex:1, minWidth:'160px' },
    label: { fontSize:'0.68rem', color:'var(--text-muted)', letterSpacing:'0.06em', textTransform:'uppercase' },
    input: { padding:'9px 12px', backgroundColor:'var(--bg-base)', border:'1px solid var(--border-light)', borderRadius:'7px', color:'var(--text-primary)', fontSize:'0.875rem', fontFamily:'IBM Plex Sans,sans-serif', outline:'none' },
    btnPrimario: { padding:'9px 20px', backgroundColor:'var(--accent)', color:'white', border:'none', borderRadius:'7px', cursor:'pointer', fontSize:'0.875rem', fontFamily:'IBM Plex Sans,sans-serif', fontWeight:'500', whiteSpace:'nowrap', alignSelf:'flex-end' },
    successBox: { backgroundColor:'rgba(16,196,138,0.08)', border:'1px solid rgba(16,196,138,0.2)', color:'var(--success)', padding:'9px 13px', borderRadius:'7px', fontSize:'0.83rem' },
    errorBox: { backgroundColor:'rgba(240,77,94,0.08)', border:'1px solid rgba(240,77,94,0.2)', color:'var(--danger)', padding:'9px 13px', borderRadius:'7px', fontSize:'0.83rem' },
    tablaWrap: { backgroundColor:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', overflow:'hidden' },
    tablaHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 20px', borderBottom:'1px solid var(--border)' },
    tablaCount: { fontSize:'0.78rem', color:'var(--text-muted)', fontFamily:'IBM Plex Mono,monospace' },
    tabla: { width:'100%', borderCollapse:'collapse' },
    th: { padding:'10px 14px', textAlign:'left', fontSize:'0.65rem', color:'var(--text-muted)', letterSpacing:'0.08em', textTransform:'uppercase', backgroundColor:'var(--bg-surface)', borderBottom:'1px solid var(--border)', whiteSpace:'nowrap' },
    td: { padding:'11px 14px', fontSize:'0.82rem', color:'var(--text-primary)', borderBottom:'1px solid var(--border)', whiteSpace:'nowrap' },
    tdMono: { fontFamily:'IBM Plex Mono,monospace', color:'var(--text-muted)', fontSize:'0.78rem' },
    tdVacio: { padding:'32px', textAlign:'center', color:'var(--text-dim)', fontSize:'0.875rem' },
    trPrimero: { backgroundColor:'rgba(47,127,255,0.04)' },
    pill: { padding:'2px 9px', borderRadius:'20px', fontSize:'0.72rem', fontWeight:'500', border:'1px solid' },
    pillVerde: { backgroundColor:'rgba(16,196,138,0.1)', color:'var(--success)', borderColor:'rgba(16,196,138,0.25)' },
    pillRojo: { backgroundColor:'rgba(240,77,94,0.1)', color:'var(--danger)', borderColor:'rgba(240,77,94,0.25)' },
    pillCyan: { backgroundColor:'rgba(0,194,212,0.1)', color:'var(--accent-cyan)', borderColor:'rgba(0,194,212,0.2)' },
    pillAmbar: { backgroundColor:'rgba(245,166,35,0.1)', color:'var(--warning)', borderColor:'rgba(245,166,35,0.25)' },
    pillGris: { backgroundColor:'rgba(90,116,153,0.15)', color:'var(--text-muted)', borderColor:'var(--border)' },
    dispBadge: { backgroundColor:'rgba(0,194,212,0.1)', border:'1px solid rgba(0,194,212,0.2)', color:'var(--accent-cyan)', padding:'2px 8px', borderRadius:'20px', fontSize:'0.72rem', fontFamily:'IBM Plex Mono,monospace' },
    usuarioBadge: { backgroundColor:'rgba(47,127,255,0.1)', border:'1px solid rgba(47,127,255,0.2)', color:'var(--accent)', padding:'2px 8px', borderRadius:'20px', fontSize:'0.72rem' },
    btnAccion: { padding:'4px 12px', borderRadius:'6px', border:'1px solid', cursor:'pointer', fontSize:'0.75rem', fontFamily:'IBM Plex Sans,sans-serif', fontWeight:'500' },
    btnDesactivar: { backgroundColor:'rgba(240,77,94,0.08)', color:'var(--danger)', borderColor:'rgba(240,77,94,0.25)' },
    btnActivar: { backgroundColor:'rgba(16,196,138,0.08)', color:'var(--success)', borderColor:'rgba(16,196,138,0.25)' },
    filtroBtn: { backgroundColor:'var(--bg-card)', border:'1px solid var(--border)', color:'var(--text-muted)', padding:'6px 14px', borderRadius:'8px', cursor:'pointer', fontSize:'0.82rem', fontFamily:'IBM Plex Sans,sans-serif' },
    filtroBtnActivo: { backgroundColor:'var(--accent-glow)', border:'1px solid var(--accent)', color:'var(--accent)' },
    btnExcel: { backgroundColor:'rgba(16,196,138,0.1)', border:'1px solid rgba(16,196,138,0.25)', color:'var(--success)', padding:'6px 14px', borderRadius:'6px', cursor:'pointer', fontSize:'0.8rem', fontFamily:'IBM Plex Sans,sans-serif' },
    btnPDF: { backgroundColor:'rgba(240,77,94,0.1)', border:'1px solid rgba(240,77,94,0.25)', color:'var(--danger)', padding:'6px 14px', borderRadius:'6px', cursor:'pointer', fontSize:'0.8rem', fontFamily:'IBM Plex Sans,sans-serif' },

    btnEditar: { backgroundColor:'rgba(47,127,255,0.12)', border:'1px solid rgba(47,127,255,0.3)', color:'var(--accent)' },
    btnReset: { backgroundColor:'rgba(245,197,24,0.12)', border:'1px solid rgba(245,197,24,0.35)', color:'#f5c518' },

    modalOverlay: { position:'fixed', inset:0, zIndex:100, backgroundColor:'rgba(0,0,0,0.6)', backdropFilter:'blur(3px)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' },
    modal: { width:'100%', maxWidth:'460px', backgroundColor:'var(--bg-card)', border:'1px solid var(--border)', borderTop:'3px solid var(--accent)', borderRadius:'14px', padding:'24px 26px', boxShadow:'0 20px 60px rgba(0,0,0,0.5)', maxHeight:'90vh', overflowY:'auto' },
    modalHeader: { display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:'8px' },
    modalSub: { fontSize:'0.65rem', color:'var(--accent)', letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:'4px' },
    modalTitulo: { fontSize:'1.2rem', fontWeight:'600', color:'var(--text-primary)' },
    modalClose: { background:'none', border:'none', color:'var(--text-muted)', fontSize:'1.6rem', lineHeight:1, cursor:'pointer', padding:0 },
    modalLabel: { fontSize:'0.68rem', color:'var(--text-muted)', letterSpacing:'0.08em', textTransform:'uppercase', display:'block', marginBottom:'6px', marginTop:'14px' },
    modalMsg: { marginTop:'14px' },
    modalAcciones: { display:'flex', gap:'10px', justifyContent:'flex-end', marginTop:'22px' },
    modalBtnCancelar: { backgroundColor:'transparent', border:'1px solid var(--border)', color:'var(--text-muted)', padding:'9px 18px', borderRadius:'8px', cursor:'pointer', fontSize:'0.85rem', fontFamily:'IBM Plex Sans,sans-serif', fontWeight:'500' },
};

export default Admin;